/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["finder-syndicated-header[_ngcontent-%COMP%]{min-height:72px;display:block}.content[_ngcontent-%COMP%]{position:relative;background:var(--app-content-background,initial)}.content[_ngcontent-%COMP%]::after{content:\" \";display:table}"];
export { styles as styles };
